package com.ervasstudio.tracoemovimento.components.custumcomponents

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res.MyColors.PretoDesfalecido
import com.ervasstudio.tracoemovimento.util.Res.MyColors.SurfaceContent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.px


@Composable
fun BotaoDesfalecido(
    nome: String,
    rota: String,
    onClick: (rota: String) -> Unit,
    isMobile: Boolean,
) {

    Box(
        modifier = Modifier.borderRadius(if (isMobile) 4.px else 10.px,)
            .cursor(Cursor.Pointer)
            .backgroundColor(color = SurfaceContent)
            .padding(
                topBottom = if (isMobile) 2.px else 8.px,
                leftRight = if (isMobile) 4.px else 18.px
            )
            .onClick { onClick(rota)}

        ,
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text = nome,
            modifier = Modifier.fontFamily("museomoderno").fontSize(if (isMobile) 6.px else 18.px)
                .color(PretoDesfalecido),
        )
    }
}